var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../Shared/KendoDataExtracter", "./BasicViewControllerWithCRUDDataSource"], function (require, exports, KendoDataExtracter_1, BasicViewControllerWithCRUDDataSource_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ViewControllerWithCustomCRUDDataSource = (function (_super) {
        __extends(ViewControllerWithCustomCRUDDataSource, _super);
        function ViewControllerWithCustomCRUDDataSource(options_, vueInitiatorObjectOverrides) {
            if (vueInitiatorObjectOverrides === void 0) { vueInitiatorObjectOverrides = { data: {}, components: {}, directives: {}, computed: {}, methods: {}, watch: {} }; }
            return _super.call(this, options_, vueInitiatorObjectOverrides) || this;
        }
        ViewControllerWithCustomCRUDDataSource.prototype.CustomRemoteDatasourceCreate = function (options) {
            var base = this;
            $.ajax({
                url: base.options.createApiUrl instanceof Function ? base.options.createApiUrl.call(this) : base.options.createApiUrl,
                type: "post", dataType: "json", contentType: "application/json",
                data: JSON.stringify(options.data),
                success: function (result) {
                    options.success(result);
                },
                error: function (result) {
                    options.error(result);
                }
            });
        };
        ViewControllerWithCustomCRUDDataSource.prototype.CustomRemoteDatasourceRead = function (options) {
            var base = this;
            $.ajax({
                url: base.options.readApiUrl instanceof Function ? base.options.readApiUrl.call(this) : base.options.readApiUrl,
                type: "get", dataType: "json", contentType: "application/json",
                success: function (result) {
                    options.success(result);
                },
                error: function (result) {
                    options.error(result);
                }
            });
        };
        ViewControllerWithCustomCRUDDataSource.prototype.CustomRemoteDatasourceUpdate = function (options) {
            var base = this;
            if (options.data == null)
                return;
            $.ajax({
                url: base.options.updateApiUrl instanceof Function ? base.options.updateApiUrl.call(this) : base.options.updateApiUrl,
                type: "put", dataType: "json", contentType: "application/json",
                data: JSON.stringify(options.data),
                success: function (result) {
                    options.success(result);
                },
                error: function (result) {
                    options.error(result);
                }
            });
        };
        ViewControllerWithCustomCRUDDataSource.prototype.CustomRemoteDatasourceDestroy = function (options) {
            var base = this;
            if (options.data == null)
                return;
            if (options.data.skipDeleteFlag) {
                options.success(true);
                return;
            }
            $.ajax({
                url: base.options.destroyApiUrl instanceof Function ? base.options.destroyApiUrl.call(this) : base.options.destroyApiUrl,
                type: "get", dataType: "json", contentType: "application/json",
                success: function (result) {
                    options.success(result);
                },
                error: function (result) {
                    options.error(result);
                }
            });
        };
        ViewControllerWithCustomCRUDDataSource.prototype.initRemoteDatasource = function () {
            var _this = this;
            var base = this;
            this.remoteDataSource = new kendo.data.DataSource({
                batch: false,
                transport: {
                    create: function (o) {
                        base.CustomRemoteDatasourceCreate(o);
                    },
                    read: function (o) {
                        base.CustomRemoteDatasourceRead(o);
                    },
                    update: function (o) {
                        base.CustomRemoteDatasourceUpdate(o);
                    },
                    destroy: function (o) {
                        base.CustomRemoteDatasourceDestroy(o);
                    },
                    parameterMap: function (data, operation) {
                        console.log("ds transport", operation, data);
                        if (operation !== "read" && data) {
                            return kendo.stringify(data);
                        }
                    }
                },
                schema: {
                    type: "json",
                    model: {
                        id: "Id",
                        fields: { Id: "Id" }
                    }
                },
                change: function (e) {
                    base.vueRoot.model = KendoDataExtracter_1.KendoDataExtracter.GetPlainDataFromKendoDatasourceEntry(e.items[0]);
                },
                requestEnd: function (e) { return _this.DSReqestEndHandler(e); },
                error: function (e) { return _this.DSErrorHandler(e); }
            });
            if (this.options.IsInEditMode)
                this.remoteDataSource.fetch(function () {
                    console.log(base.remoteDataSource.hasChanges());
                });
            else
                this.remoteDataSource.add(this.GetNewInstanceOfType(this.options.type));
        };
        return ViewControllerWithCustomCRUDDataSource;
    }(BasicViewControllerWithCRUDDataSource_1.BasicViewControllerWithCRUDDataSource));
    exports.ViewControllerWithCustomCRUDDataSource = ViewControllerWithCustomCRUDDataSource;
    $(function () {
        var optionsList = window["ViewControllerWithCustomCRUDDataSourceData"];
        for (var i in optionsList) {
            window["ViewControllerWithCustomCRUDDataSource" + i] = new ViewControllerWithCustomCRUDDataSource(optionsList[i]);
        }
    });
});
//# sourceMappingURL=ViewControllerWithCustomCRUDDataSource.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/ViewControllerWithCustomCRUDDataSource.js
// module id = 161
// module chunks = 0